/** 仅用于素材身份匹配：忽略会刷新的签名、展示参数及缩略图后缀，不改写实际请求 URL。 */
export function getMyIpMediaResourceKey(value: unknown): string {
  if (typeof value !== 'string') return '';
  const raw = value.trim();
  try {
    const url = new URL(raw);
    url.hash = '';
    [url.pathname] = url.pathname.split('!');
    // 签名和缩略图参数不改变媒体身份；id 等业务参数仍区分不同内容。
    for (const key of [...url.searchParams.keys()]) {
      if (/^(k|t|sign|signature|token|expires|auth_key|tfcache|imageView2.*|imageMogr2.*|x-oss-process|x-oss-.*|x-amz-.*)$/i.test(key)) url.searchParams.delete(key);
    }
    url.searchParams.sort();
    return url.toString();
  } catch { return raw; }
}

/** 只使用明确的 HTTP(S) 媒体地址，拒绝凭据和临时协议并原样保留签名参数。 */
export function getMyIpMediaUrl(value: unknown): string | undefined {
  if (typeof value !== 'string' || !value.trim()) return undefined;
  try {
    const url = new URL(value);
    return ['https:', 'http:'].includes(url.protocol) && !url.username && !url.password ? value : undefined;
  } catch {
    return undefined;
  }
}
